var React = require('react');

function Bookmark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("g",{"data-name":"1","id":"_1","key":1},React.createElement("path",{"d":"M393,450a14.92,14.92,0,0,1-7.46-2L257,374.29,128.46,448A15,15,0,0,1,106,435V63a15,15,0,0,1,15-15H393a15,15,0,0,1,15,15V435a15,15,0,0,1-15,15ZM257,342a14.92,14.92,0,0,1,7.46,2L378,409.1V78H136V409.1L249.54,344A14.92,14.92,0,0,1,257,342Z"}))]);
}

Bookmark.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Bookmark;

Bookmark.default = Bookmark;
